import { atomWithHash } from 'jotai-location'

export const orderIdAtom = atomWithHash('orderId', '')
export const orderOperatorCardIdAtom = atomWithHash('operatorCardId', '')
export const purchaseIdNewApiAtom = atomWithHash('purchaseId', '')
export const orderIdNewApiAtom = atomWithHash('orderId', '')
export const isDealerAtom = atomWithHash('isDealer', undefined)
